import { Link } from 'react-router-dom';
import type { BlogPost } from '../../../mocks/blogPosts';

interface BlogCardProps {
  post: BlogPost;
  variant?: 'default' | 'featured';
}

export default function BlogCard({ post, variant = 'default' }: BlogCardProps) {
  if (variant === 'featured') {
    return (
      <Link
        to={`/blog/${post.slug}`}
        className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-primary-gold/30 transition-all duration-300 cursor-pointer block"
      >
        <div className="relative h-72 overflow-hidden">
          <img
            src={post.imageUrl}
            alt={post.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#06030f] via-[#06030f]/50 to-transparent" />
          <div className="absolute top-4 left-4">
            <span className="px-3 py-1 rounded-full bg-primary-gold/20 border border-primary-gold/40 text-primary-gold text-xs font-semibold">
              추천
            </span>
          </div>
        </div>
        <div className="p-6 bg-white/3">
          <p className="text-primary-gold/70 text-xs font-medium uppercase tracking-widest mb-2">{post.category}</p>
          <h3 className="text-white font-bold text-xl mb-2 group-hover:text-primary-gold transition-colors leading-snug">{post.title}</h3>
          <p className="text-purple-300/60 text-sm mb-4 line-clamp-2 leading-relaxed">{post.excerpt}</p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3 text-xs text-purple-400/60">
              <span>{post.publishedAt}</span>
              <span>·</span>
              <span>읽기 {post.readingTime}분</span>
            </div>
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-right-line text-primary-gold/50 group-hover:text-primary-gold group-hover:translate-x-1 transition-all text-sm"></i>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group flex gap-4 p-5 rounded-2xl border border-white/8 bg-white/2 hover:border-primary-gold/20 hover:bg-white/4 transition-all duration-300 cursor-pointer"
    >
      <div className="w-24 h-24 flex-shrink-0 rounded-xl overflow-hidden">
        <img
          src={post.imageUrl}
          alt={post.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-primary-gold/60 text-[10px] font-semibold uppercase tracking-widest mb-1">{post.category}</p>
        <h3 className="text-white font-bold text-sm mb-1.5 group-hover:text-primary-gold transition-colors line-clamp-2 leading-snug">
          {post.title}
        </h3>
        <p className="text-purple-300/50 text-xs line-clamp-2 leading-relaxed mb-2">{post.excerpt}</p>
        <div className="flex items-center gap-2 text-[10px] text-purple-400/50">
          <span>{post.publishedAt}</span>
          <span>·</span>
          <span>{post.readingTime}분</span>
        </div>
      </div>
    </Link>
  );
}
